import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { ELEVES_VIEWS_KEY } from '@teetsh/app/src/queries/eleves/views/useElevesViews';

function reorderEleveView(props: {
  schoolyearId: string;
  schoolId: string;
  viewIds: string[];
}) {
  const requestURL = `/schoolyears/${props.schoolyearId}/schools/${props.schoolId}/eleves-views/reorder`;
  return request(requestURL, {
    method: 'PATCH',
    body: props.viewIds,
  });
}

export default function useReorderElevesView() {
  const { schoolyear, school } = useSchoolSchoolyear();
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation({
    mutationFn: (viewIds: string[]) =>
      reorderEleveView({
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        viewIds,
      }),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ELEVES_VIEWS_KEY],
      });
    },
  });
  return mutateAsync;
}
